// Data
import { getCountriesAsOptions, getRegionsAsOptions } from '../data';

// Constants
import { SITE_URL } from '../config';

export const geURLParameters = () => {
  const search = location.search.substring(1);
  let params = {};

  if (search) {
    params = JSON.parse(
      `{"${decodeURI(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')}"}`
    );
  }

  return params;
};

export const slugify = string => string.toLowerCase().replace(/\ /g, '-');

export const setCountrySelectOptions = (input, options = {}) => {
  let optionsHTML = '<option value="">Select One</option>';
  const countries = getCountriesAsOptions();
  const { defaultValue = '' } = options;

  countries.forEach(
    ({ label, value }) =>
      (optionsHTML += `<option value="${value}"${
        defaultValue === value ? 'selected="selected"' : ''
      }>${label}</option>`)
  );

  input.empty();
  input.append(optionsHTML);
};

export const setStateSelectOptions = (
  input,
  countryShortCode,
  options = {}
) => {
  let optionsHTML = '<option value="">Select One</option>';
  const { defaultValue = '' } = options;

  if (countryShortCode) {
    const states = getRegionsAsOptions(countryShortCode);

    states.forEach(
      ({ label, value }) =>
        (optionsHTML += `<option value="${value}"${
          defaultValue.value === value ? 'selected="selected"' : ''
        }>${label}</option>`)
    );
  }

  input.empty();
  input.attr('disabled', !countryShortCode ? true : false);
  input.append(optionsHTML);
};

export const replaceSiteUrl = url => {
  if (!url) return '';

  url = new URL(url);

  return `${SITE_URL}${url.pathname}`;
};
